// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"371":"e22d8267","453":"daf7a06c"}[chunkId] + ".chunk.js";
};